// v-marquee — names cut off with "…" slowly scroll back and forth while hovered
// (the card or row containing them counts as the hover target). Uses Motion.

import { animate } from "motion";

const SPEED = 40; // px per second

function start(el) {
	const inner = el._marqueeInner;
	if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
	// Measure as a block (an inline span has no width of its own)
	el.classList.add("marquee-active");
	const overflow = inner.scrollWidth - el.clientWidth;
	if (overflow <= 2) {
		el.classList.remove("marquee-active");
		return;
	}
	const travel = overflow + 8;
	const seconds = Math.max(1.2, travel / SPEED);
	el._marquee = animate(
		inner,
		{ x: [0, 0, -travel, -travel, 0] },
		{
			duration: seconds * 2 + 1.6,
			times: [0, 0.12, 0.5, 0.62, 1],
			ease: "easeInOut",
			repeat: Infinity,
		}
	);
}

function stop(el) {
	el._marquee?.stop();
	el._marquee = null;
	el.classList.remove("marquee-active");
	animate(el._marqueeInner, { x: 0 }, { duration: 0.25 });
}

export default {
	mounted(el, binding) {
		// Wrap the text so it can move inside the clipped element
		const inner = document.createElement("span");
		inner.className = "marquee-inner";
		while (el.firstChild) inner.appendChild(el.firstChild);
		el.appendChild(inner);
		el._marqueeInner = inner;
		const host = (binding.value && el.closest(binding.value)) || el;
		el._marqueeEnter = () => start(el);
		el._marqueeLeave = () => stop(el);
		host.addEventListener("mouseenter", el._marqueeEnter);
		host.addEventListener("mouseleave", el._marqueeLeave);
		el._marqueeHost = host;
	},
	updated(el) {
		// Vue may re-render the text outside the wrapper; fold it back in
		const inner = el._marqueeInner;
		[...el.childNodes].forEach(n => n !== inner && inner.appendChild(n));
	},
	beforeUnmount(el) {
		el._marquee?.stop();
		el._marqueeHost?.removeEventListener("mouseenter", el._marqueeEnter);
		el._marqueeHost?.removeEventListener("mouseleave", el._marqueeLeave);
	},
};
